/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosPromise } from "axios";
import getApi, { getApiFromStorage, type SiteType } from "./api";
import { Filters, RechargeFilter } from "../interfaces/recharge";

interface Banners {
  backgroundCor: string;
  backgroundImage: string;
  banner_type: string;
  created_at: string;
  cta_color: string;
  cta_text: string;
  id: number;
  is_active: boolean;
  media_link: string;
  updated_at: string;
}

const ConvertArrayFilterToObject = (filters: Filters = {}): RechargeFilter => {
  try {
    const object = filters.reduce(
      (obj: any, item: any) => ({ ...obj, ...item }),
      {}
    );
    return object;
  } catch (err) {
    return {};
  }
};

const SerializeFilters = (filters: any): string => {
  const str = [];
  for (const p in filters) {
    if (filters.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(filters[p])}`);
    }
  }
  return str.join("&");
};
const api = getApiFromStorage();

console.log(api);

class CoreService {
  private api() {
    return getApiFromStorage();
  }

  private withPrefix(url: string): string {
    const siteType =
      (localStorage.getItem("@Admin:siteType") as SiteType) || "PF";
    return siteType === "PJ" ? `api/${url}` : url;
  }

  getBannersMobile = (): AxiosPromise => {
    const url = "core/manager/banner-mobile/";
    return getApi("PF").get(url);
  };

  getBannerMobId = (id: string): AxiosPromise => {
    const url = `/core/manager/banner-mobile/${id}/`;
    return getApi("PF").get(url);
  };

  patchBannerMob = (id: string, data: any) => {
    return getApi("PF").patch(`/core/manager/banner-mobile/${id}/`, data);
  };

  postBannerMob = (data: any) => {
    return getApi("PF").post("/core/manager/banner-mobile/", data);
  };

  deleteBannerMobId = (id: string): AxiosPromise => {
    const url = `/core/manager/banner-mobile/${id}/`;
    return getApi("PF").delete(url);
  };

  getBannersWeb = (): AxiosPromise => {
    const url = "core/manager/banner-web/";
    return getApi("PF").get(url);
  };

  getBannerWebId = (id: string): AxiosPromise => {
    const url = `/core/manager/banner-web/${id}/`;
    return getApi("PF").get(url);
  };

  patchBannerWeb = (id: string, data: any) => {
    return getApi("PF").patch(`/core/manager/banner-web/${id}/`, data);
  };

  postBannerWeb = (data: any) => {
    return getApi("PF").post("/core/manager/banner-web/", data);
  };

  deleteBannerWebId = (id: string): AxiosPromise => {
    const url = `/core/manager/banner-web/${id}/`;
    return getApi("PF").delete(url);
  };

  getAppVersion = (): AxiosPromise => {
    const url = "core/manager/app-version/";
    return getApi("PF").get(url);
  };

  patchAppVersion = (id: string, data: any) => {
    return getApi("PF").patch(`/core/manager/app-version/${id}/`, data);
  };

  deleteAppVersion = (id: string): AxiosPromise => {
    const url = `/core/manager/app-version/${id}/`;
    return getApi("PF").delete(url);
  };

  getAppVersionId = (id: string): AxiosPromise => {
    const url = `/core/manager/app-version/${id}/`;
    return getApi("PF").get(url);
  };

  postAppVersion = (data: any) => {
    return getApi("PF").post("/core/manager/app-version/", data);
  };

  getRecargaLogs = (filters?: Filters, id?: string): AxiosPromise => {
    const convertedFilters = ConvertArrayFilterToObject(filters.filters);
    const url =
      Object.keys(convertedFilters).length === 0
        ? `ticketing/manager/recharge-request-log/?recharge_id=${id}`
        : `ticketing/manager/recharge-request-log/?recharge_id=${id}&${SerializeFilters(
            convertedFilters
          )}`;
    return getApi("PF").get(url);
  };

  postRecargaUpdate = (id: string): AxiosPromise => {
    const url = `ticketing/manager/recharge-request/${id}/check/`;
    return getApi("PF").post(url);
  };

  postCancelarRecargaQrCode = (id: string): AxiosPromise => {
    const url = `ticketing/manager/recharge-request/${id}/cancel-recharge/`;
    return getApi("PF").post(url);
  };

  getSettings = (): AxiosPromise => {
    return this.api().get(this.withPrefix("settings/"));
  };

  patchSettings = (data: any, config?: any): AxiosPromise => {
    return this.api().patch(this.withPrefix("settings/update/"), data, config);
  };

  patchSettingsID = (id: any, data: any, config: any): AxiosPromise => {
    return this.api().patch(this.withPrefix(`settings/${id}/`), data, config);
  };
}

export type { Banners };

export default CoreService;
